module.exports = __webpack_public_path__ + "static/bob1-d2b696efa51e55317ac625b9004f9ebe.png";